import { c } from 'bowser'
import LogRocket from 'logrocket'

const appID = 'j8uy8j/ss-ui'

const LRInit = () => {
  try {
    LogRocket.init(appID)
  } catch (e) {
    console.log('LogRocket init failed:', e.message)
  }
}

const LRIdentify = (id, user) => {
  try {
    LogRocket.identify(user.username, user)
  } catch (e) {
    console.log('LogRocket identify failed:', e.message)
  }
}

const LRBeforeSend = (data) => {
  try {
    data.metaData.sessionURL = LogRocket.sessionURL
    return data
  } catch (e) {
    console.log('LogRocket beforeSend failed:', e.message)
  }
}

export { LRInit, LRIdentify, LRBeforeSend }
